export async function getVisitorList(baseUrl, room) {
    const uri = `${baseUrl}api/v2/room/visitors?roomToken=${room}`;
    let result = null;
    try {
        const response = await fetch(uri);
        result = await response.json();
    }
    catch (error) {
        console.error(error);
        return {
            result: null,
            error: 'No response'
        };
    }
    return result;
}
